
export interface C_VALUE {
    c_VALUE: number
}
export enum ClampexType {
    KTR100 = 'KTR100',
    KTR105 = 'KTR105',
    KTR130 = 'KTR130',
    KTR131 = 'KTR131',
    KTR150 = 'KTR150',
    KTR200 = 'KTR200',
    KTR201 = 'KTR201',
    KTR203 = 'KTR203',
    KTR206 = 'KTR206',
    KTR225 = 'KTR225',
    KTR250 = 'KTR250',
    KTR400 = 'KTR400',
    KTR700 = 'KTR700'
}